import React from 'react';
import { MdTrendingUp, MdTrendingDown } from 'react-icons/md';
import '../../../../assets/css/components/seller/cards/stats/StatsCard.css';

const StatCard = ({ icon, color, label, value, change, trend }) => {
  return (
    <div className="stat-card">
      <div className="stat-header">
        <div className={`stat-icon stat-icon-${color}`}>
          {icon}
        </div>
        <div className={`stat-badge ${trend === 'up' ? 'stat-badge-success' : 'stat-badge-danger'}`}>
          {trend === 'up' ? <MdTrendingUp /> : <MdTrendingDown />}
          {change}
        </div>
      </div>
      <div className="stat-body">
        <h6>{label}</h6>
        <h3>{value}</h3>
      </div>
    </div>
  );
};

export default StatCard;
